'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useEffect, useRef, useState } from 'react'

import { useFamilies } from '../../../contexts/FamiliesProvider/FamiliesProvider'
import { getClientEquivalences } from '../../../services/getEquivalences/client/getClientEquivalences'
import type { SizeGuideEquivalencesList } from '../../../types/SizeGuide.types'
import { SizeGuidesList } from '../SizeGuidesList/SizeGuidesList'

import text from 'fukku/styles/texts.module.scss'

interface EquivalencesProps {
	readonly initialEquivalences: SizeGuideEquivalencesList[]
	readonly className?: string
}

export function Equivalences({
	initialEquivalences,
	className,
}: EquivalencesProps): React.ReactNode {
	const {
		country: { languageISO },
	} = useMasterData()
	const { selectedFamilyId } = useFamilies()
	const { t } = useLabels()

	const [equivalences, setEquivalences] = useState(initialEquivalences)
	const firstRenderRef = useRef(true)

	useEffect(() => {
		const fetchEquivalences = async () => {
			const { equivalences: fetchedEquivalences } = await getClientEquivalences(
				{
					languageISO,
					familyId: selectedFamilyId,
				}
			)

			setEquivalences(fetchedEquivalences)
		}

		if (!firstRenderRef.current) {
			fetchEquivalences()
		} else {
			firstRenderRef.current = false
		}
	}, [selectedFamilyId])

	if (!equivalences.length) {
		return null
	}

	return (
		<div className={className} data-testid='size-guide-equivalences'>
			<h2 className={text.titleL}>
				{t('sizeGuide.internationalEquivalence.title')}
			</h2>
			<div>
				<SizeGuidesList data={equivalences} cellHeight={40} isHighlightable />
			</div>
		</div>
	)
}
